import React, {useState} from 'react';
import BtnSearch from "../../components/buttons/BtnSearch";
import BtnSearchDetail from "../../components/buttons/BtnSearchDetail";
import InputSearchText from "../../components/input/InputSearchText";
import TableSizeSelect from "../select/TableSizeSelect";
import JellyCheckBox from "./JellyCheckBox";
import {isMobile} from "../commonmethod/CommonMethod";
import DataPickerWithSelector from "../datepicker/DataPickerWithSelector";
import {RotateCcw} from "lucide-react";
import SearchDetailDrawer from "./SearchDetailDrawer";
import "./searchBar.css";


/**
 * `검색 `조건검색 `서치
 * Listener : 검색실행 메서드
 * setSearchObject : 검색조건을 세팅하는 메서드
 * children : 검색 검포넌트에 표시될 자신컴포넌트
 *        <SearchComponent> 를 호출하는 부모 컴포넌트에서  
 *            <children />
 *            <children />
 *            <children />
 *            ....
 *        </SearchComponent> 이런식으로 넣어주면 children에 담긴다
 * */



function SearchComponent({title, Listener, search, setPageable, children, dated, invisible, fix, placeholder, refresh} ) {
    const [isDetailOpen, setIsDetailOpen] = useState(false);    //상새검색 버튼을 눌렀는지 감지
    const aaa=()=>{
    }
    return (
        <div className="relative search-bar-root overflow-visible">
        <div className="search-compo">
            <div className={`${isMobile ? '':'flex'} `}>
                {invisible && invisible.search?
                    <></> :
                    <>
                    <InputSearchText title={title} Listener={Listener} search={search} setPageable={setPageable} placeholder={placeholder} />
                    {!isMobile &&
                        <BtnSearch Listener={Listener} setPageable={setPageable}/>
                    }
                    </>
                }
                {/* 초기화 버튼 추가 */}
                {refresh && (
                    <button
                        type="button"
                        className="search-reset-btn"
                        title="검색조건 초기화"
                        aria-label="검색조건 초기화"
                        onClick={() => {
                            window.dispatchEvent(new CustomEvent("simms:reset-drawers"));
                            refresh();
                        }}
                    >
                        <RotateCcw size={15} strokeWidth={2} aria-hidden="true" />
                    </button>
                )}
                {invisible && invisible.size?
                    <></> : <TableSizeSelect Listener={Listener} setPageable={setPageable} />
                }
                {invisible && invisible.detail?
                    <></> : <BtnSearchDetail isDetailOpen={isDetailOpen} setIsDetailOpen={setIsDetailOpen}/>
                }
                {invisible && invisible.date?
                    <></> :
                    <>
                        <span className="ml-2 mr-2 text-[12px] line-height-30">{title}</span>
                        <DataPickerWithSelector date={dated.date.from} limit={dated.date.to} setDate={dated.fnc} target={"startDate"} search={search} start={true} />
                        <span className="ml-2 mr-2 text-[20px]"> ~ </span>
                        <DataPickerWithSelector date={dated.date.to} limit={dated.date.from} setDate={dated.fnc} target={"endDate"}  search={search} start={false} />
                    </>

                }
                {invisible && invisible.fix?
                    <></> : <JellyCheckBox title={"검색조건 고정"} checked={fix} fnc={aaa} />
                }

            </div>
        </div>

            {!(invisible && invisible.detail) &&
                <SearchDetailDrawer open={isDetailOpen} onClose={() => setIsDetailOpen(false)}>
                    {children}
                </SearchDetailDrawer>
            }
        </div>
    );
}

export default SearchComponent;